import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { media } from 'src/styles/designs';
import { EventPageAgendaHeader } from 'src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaHeader';
import { EventPageAgendaSchedule } from 'src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaSchedule';
import { useEventAgendaSchedule } from 'src/modules/events/hooks/useEventAgendaSchedule';
import { withQueries } from 'src/utils/reactQuery';
import { useCurrentEventAgendaQuery } from 'src/modules/events/hooks/useEventAgendaQuery';
import { EventPageContext } from 'src/modules/events/components/EventPage/EventPageContext';
import { ScrollToViewport } from 'src/components/common/ScrollToViewport';
import { useRouter } from 'next/router';
import { useUserQuery } from 'src/modules/user/hooks/useUserQuery';
import { useDispatchAction } from 'vendor/hooks/useDispatchAction';
import { AppAction } from 'src/store/actions';
import { AuthorizationModalMode } from 'src/modules/modals/types';
import { useSelector } from 'react-redux';

const Section = styled.section`
  padding: 20px 0 34px;
  background: ${({ theme }) => theme.palette.background};
  ${media.w.greaterThanOrEqual.desktop} {
    padding: 54px 0 76px;
  }
`;

const Container = styled(ConstraintContainer)`
  max-width: 1020px;
`;

const ContentContainer = styled(ConstraintContainer)`
  max-width: 855px;
  padding: 0 !important;
`;

export const EventPageAgendaSection = withQueries(
  {
    data: useCurrentEventAgendaQuery,
  },
  ({ data }) => {
    const { event } = useContext(EventPageContext);
    const schedule = useEventAgendaSchedule(data, event.id);

    const user = useUserQuery();
    const router = useRouter();

    const openModals = useSelector((s) => s.modals.openModals);
    const openModal = useDispatchAction(AppAction.modalOpen);

    useEffect(() => {
      if (!user.data && !user.isLoading && router.query.ticket) {
        openModal({
          kind: 'authorization',
          mode: AuthorizationModalMode.Login,
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.isLoading]);

    return (
      <ScrollToViewport
        active={!!router.query.ticket && !!user.data && !openModals.length}
        options={true}
        scrollOnMount={true}
      >
        <Section>
          <Container>
            <EventPageAgendaHeader schedule={schedule} agenda={data} />
            <ContentContainer>
              <EventPageAgendaSchedule schedule={schedule} />
            </ContentContainer>
          </Container>
        </Section>
      </ScrollToViewport>
    );
  },
);
